export function buildStatementVoteMessage(input: {
  index: number;
  support: "yes" | "no";
  source: "wallet" | "stake";
  amount: string;
  wallet: string;
  nonce?: string;
}): string {
  return [
    "AranDAO — Statement vote",
    `Statement: ${input.index}`,
    `Support: ${input.support}`,
    `Source: ${input.source}`,
    `Amount: ${input.amount}`,
    `Wallet: ${input.wallet.toLowerCase()}`,
    ...(input.nonce ? [`Vote: ${input.nonce}`] : []),
  ].join("\n");
}
